import TrashList from './TrashList';

// Thùng rác mở dạng hộp thoại từ trang chủ
export default function TrashDialog({ onRestored, onClose }) {
  return (
    <div className="dialog-backdrop" onClick={onClose}>
      <div className="dialog trash-dialog" onClick={(e) => e.stopPropagation()} role="dialog" aria-label="Thùng rác">
        <div className="trash-dialog-head">
          <h2>Thùng rác</h2>
          <button onClick={onClose}>Đóng</button>
        </div>
        <TrashList onRestored={onRestored} />
      </div>
    </div>
  );
}
